module.exports = __webpack_public_path__ + "img/qx_power_2u.167a9277.png";